/**
 * Auto-fill decision for the drug Registry ID field when the external codes
 * change. Mirrors drcfo.frontend's utils/terminology nextRegistryId so both
 * apps fill the field the same way.
 *
 * Entering codes fills the field with the primary (first) code; changing the
 * codes replaces a value this helper wrote; removing every code clears it
 * again. A value the admin typed by hand is never touched. Returns the next
 * field value, or null when the field must stay as it is. `lastAuto` is
 * whatever value the previous auto-fill wrote ("" when none).
 */
export const nextRegistryId = (current, lastAuto, codes = []) => {
  const trimmed = String(current || "").trim();
  if (trimmed && trimmed !== lastAuto) return null; // manual entry — hands off
  return codes?.[0]?.code || "";
};
